"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Background = exports.Portal = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const react_transition_group_1 = require("react-transition-group");
const react_dom_1 = require("react-dom");
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const base_ui_components_atoms_button_1 = require("@motorata/base-ui.components.atoms.button");
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const Portal = ({ id, children }) => {
    const [mounted, setMounted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);
    return mounted ? (0, react_dom_1.createPortal)(children, document.querySelector(`#${id}`)) : null;
};
exports.Portal = Portal;
const Modal = ({ children, show, setShow, type = "center", maxWidth = "500px", maxHeight = "none", icon, title, text, background = "white", color = "second", borderColor = "fourth", contentPadding, modalBackgroundId = "root-modal-background", modalContentId = "root-modal-content", }) => {
    let childrenElement;
    if (children) {
        if (Array.isArray(children)) {
            childrenElement = [];
            children.map(el => childrenElement.push(react_1.default.cloneElement(el, { setShow: setShow })));
        }
        else {
            childrenElement = react_1.default.cloneElement(children, { setShow: setShow });
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.Portal, { id: modalBackgroundId },
            react_1.default.createElement(react_transition_group_1.CSSTransition, { in: show, timeout: 200, classNames: "background", unmountOnExit: true },
                react_1.default.createElement(exports.Background, { onClick: setShow ? () => setShow(false) : () => { } }))),
        react_1.default.createElement(exports.Portal, { id: modalContentId },
            react_1.default.createElement(react_transition_group_1.CSSTransition, { in: show, timeout: 200, classNames: "content", unmountOnExit: true },
                react_1.default.createElement(Wrapper, { type: type, maxWidth: maxWidth, maxHeight: maxHeight, className: `hide_scroll` },
                    react_1.default.createElement(InnerWrapper, { background: background, className: `sidebar_block hide_scroll` },
                        title && (react_1.default.createElement(TitleContent, { borderColor: borderColor },
                            react_1.default.createElement(base_ui_components_atoms__atoms_1.Box, null,
                                react_1.default.createElement(base_ui_components_atoms_typography_1.LabelH3, { margin: "0", color: color }, title),
                                text && (react_1.default.createElement(base_ui_components_atoms_typography_1.P, { small: true, margin: "0", marginTop: "XS", color: color }, text))),
                            setShow && react_1.default.createElement(base_ui_components_atoms_button_1.IconButton, { icon: "close", color: color, onClick: () => setShow(false) }))),
                        react_1.default.createElement(Content, { contentPadding: contentPadding }, childrenElement)))))));
};
exports.default = Modal;
const Content = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  padding: ${({ theme, contentPadding }) => { var _a; return contentPadding ? (_a = theme.space[contentPadding]) !== null && _a !== void 0 ? _a : contentPadding : theme.space.S; }};
  white-space: break-spaces;
`;
const TitleContent = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  padding: ${({ theme }) => theme.space.S};
  border-bottom: 1px solid ${({ theme, borderColor }) => theme.color[borderColor]};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
const InnerWrapper = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  background: ${({ theme, background }) => theme.color[background]};
  padding: 0px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.variable.boxShadow};
  margin-bottom: 1rem;
`;
const Wrapper = styled_components_1.default.div `
  max-width: ${({ maxWidth }) => maxWidth};
  max-height: ${({ maxHeight }) => maxHeight};
  opacity: 1;
  z-index: 100;
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow: scroll;

  > div {
    margin: 0 !important;
    height: 100%;
    overflow: scroll;
  }

  ${({ type }) => type === "center" &&
    (0, styled_components_1.css) `
      max-height: 90%;
      width: 90% !important;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 5px;

      > div {
        border-radius: 5px;
      }

      &.content-enter {
        opacity: 0;
        transform: translate(-50%, calc(-50% + 30px));
      }

      &.content-enter-active {
        opacity: 1;
        transform: translate(-50%, -50%);
        transition: opacity 200ms, transform 0.2s;
      }

      &.content-exit {
        opacity: 1;
        transform: translate(-50%, -50%);
      }

      &.content-exit-active {
        opacity: 0;
        transform: translate(-50%, calc(-50% + 30px));
        transition: opacity 200ms, transform 0.2s;
      }
    `};

  ${({ type }) => type === "side" &&
    (0, styled_components_1.css) `
      width: 100% !important;
      height: 100%;
      right: 0;
      top: 0;
      transform: translate(0, 0);

      &.content-enter {
        transform: translate(100%, 0);
      }

      &.content-enter-active {
        transform: translate(0, 0);
        transition: opacity 200ms, transform 0.2s;
      }

      &.content-exit {
        transform: translate(0, 0);
      }

      &.content-exit-active {
        transform: translate(100%, 0);
        transition: opacity 200ms, transform 0.2s;
      }
    `};
`;
exports.Background = styled_components_1.default.div `
  background: rgba(0, 0, 0, 0.8);
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 99;

  &.background-enter {
    opacity: 0;
  }

  &.background-enter-active {
    opacity: 1;
    transition: opacity 200ms;
  }

  &.background-exit {
    opacity: 1;
  }

  &.background-exit-active {
    opacity: 0;
    transition: opacity 200ms;
  }
`;
//# sourceMappingURL=Modal.js.map